var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ login: _vm.login.role == null },attrs:{"id":"app"}},[(_vm.login.role != null)?_c('topPanel'):_vm._e(),_c('spinner'),_c('notificator'),(_vm.login.role == 'User')?_c('user'):(_vm.login.role == 'Judge')?_c('judge'):(_vm.login.role == 'Admin')?_c('admin'):_c('login'),_c('footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }